import { __awaiter, __generator } from "tslib";
import { fetchFormattedPrice } from '@gn-audio/core/api/pricing/utilities';
/**
 * @internal
 */
export var getFormattedDiscountedPrice = function (productPrice, servicesPrices, accessoriesPrices) { return __awaiter(void 0, void 0, void 0, function () {
    function calculateTotalPrice(prices) {
        return (prices === null || prices === void 0 ? void 0 : prices.map(function (price) { return (price.discountedPrice || price.c_discountedPrice || 0); }).reduce(function (previous, current) { return previous + current; }, 0)) || 0;
    }
    var productDiscountedPriceFormatted, productDiscountedPrice, totalAccessoriesPrice, totalServicesPrice, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!productPrice) {
                    return [2 /*return*/];
                }
                productDiscountedPriceFormatted = productPrice.formattedDiscountedPrice
                    || productPrice.c_formattedDiscountedPrice
                    || productPrice.formattedFromDiscountedPrice;
                productDiscountedPrice = [
                    productPrice.discountedPrice,
                    productPrice.c_discountedPrice,
                    productPrice.fromDiscountedPrice,
                ].find(function (price) { return typeof price !== 'undefined' && price != null && price >= 0; });
                if (typeof productDiscountedPrice === 'undefined') {
                    return [2 /*return*/];
                }
                totalAccessoriesPrice = calculateTotalPrice(accessoriesPrices);
                totalServicesPrice = calculateTotalPrice(servicesPrices);
                if (!(servicesPrices || accessoriesPrices)) return [3 /*break*/, 2];
                return [4 /*yield*/, fetchFormattedPrice(productDiscountedPrice + totalAccessoriesPrice + totalServicesPrice)];
            case 1:
                _a = (_b = (_c.sent())) === null || _b === void 0 ? void 0 : _b.formattedPrice;
                return [3 /*break*/, 3];
            case 2:
                _a = Promise.resolve(productDiscountedPriceFormatted);
                _c.label = 3;
            case 3: return [2 /*return*/, _a];
        }
    });
}); };
